import { graphql } from "gatsby"
import React from "react"
import { Layout } from "@bw/layouts"
import { Seo, Section, CmsImage } from "@bw/bits"
import { PageHeader, Teasers } from "@bw/modules"
import { Teaser, SidebarLayout, Breadcrumbs } from "@bw/partials"

const TaxonomyTemplate = ({ data, pageContext, location }) => {
  const { category, articles, mount, categories } = data

  const breadcrumbsLinks = [
    {
      title: "Accueil",
      to: "/",
    },
    {
      title: mount.title,
      to: mount.slug,
    },
    {
      title: category.title,
      to: `/${category.slug}`,
    },
  ]

  return (
    <Layout color={category.color?.value} {...{ pageContext }}>
      <Seo
        url={location.href}
        title={category.title}
        meta={[
          {
            name: "robots",
            content: "max-image-preview:large, index, follow",
          },
        ]}
      />
      <PageHeader
        title={category.title}
        image={
          category.image ? (
            <CmsImage src={category.image.url} alt="" />
          ) : undefined
        }
        pictogram={
          <svg className="icon">
            <use xlinkHref="/sprite-v2.svg#cross" />
          </svg>
        }
      />
      {breadcrumbsLinks && <Breadcrumbs breadcrumbs={breadcrumbsLinks} />}
      <SidebarLayout
        sidemenu={categories.nodes.map(c => ({
          title: c.title,
          slug: mount.slug + "/" + c.slug,
        }))}
      >
        <Section>
          <Teasers>
            {articles.nodes.map((item, i) => {
              return (
                <Teaser
                  key={i}
                  title={item.title}
                  excerpt={item.teaserExcerpt}
                  image={
                    <CmsImage
                      src={item.teaserImage || "/placeholder-teaser.jpg"}
                      alt={item.title}
                    />
                  }
                  to={item.slug}
                />
              )
            })}
          </Teasers>
        </Section>
      </SidebarLayout>
    </Layout>
  )
}

export default TaxonomyTemplate

export const taxonomyQuery = graphql`
  query taxonomyQuery($slug: String!, $id: String!) {
    category: taxonomyCategory(id: { eq: $id }) {
      locale
      title
      id
      url
      image {
        url
      }
      color {
        value
      }
    }
    categories: allTaxonomyCategory(
      filter: { entries_count: { gt: 0 } }
      sort: { title: ASC }
    ) {
      nodes {
        title
        slug
      }
    }
    articles: allCollectionArticles(
      filter: { category: { slug: { eq: $slug } } }
    ) {
      nodes {
        title
        slug
        teaserExcerpt
        teaserImage {
          localImage {
            childImageSharp {
              gatsbyImageData(width: 350, height: 175)
            }
          }
        }
      }
    }
    mount: collectionPages(mount: { handle: { eq: "articles" } }) {
      slug
      title
      header {
        ... on PageHeaderModule {
          image {
            url
          }
        }
      }
    }
  }
`
